import { Input } from "@vds/inputs";
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

export const CustomInputWrapper = styled.div`
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  & div {
    margin-left: 0;
    max-width: 100%;
    height: unset !important;
    display: flex;
    width: auto;

    & label {
      & p {
        font-family: "neue-haas-grotesk-text";
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 12px;
        margin-bottom: 8px;
        color: rgb(0, 0, 0);
        display: inline;
        letter-spacing: 0;
        display: ${(props) => (props.required ? "grid" : "")};
        grid-template-columns: ${(props) => (props.required ? "1fr 10px" : "")};
        & span {
          display: ${(props) => (props.required ? `block` : "none")};
          &::after {
            content: ${(props) => (props.translationContent ? `${props.translationContent}` : "")};
            display: none;
          }
        }
      }
    }
    & span {
      & span {
        & div {
          & p {
            color: #c44904;
            font-family: "neue-haas-grotesk-text";
            font-style: normal;
            font-size: 12px;
            line-height: 12px;
          }
        }
        & span {
          box-sizing: border-box;
          border: 1px solid #e0e0e0 !important;
          border: ${(props) => !props.isError && "1px solid #e0e0e0 !important"};
          border-radius: 4px;
          max-width: 100%;
          background-color: transparent;
        }
        & span:first-child {
          border: ${(props) => props.isError && "1px solid #c44904 !important"};
          & div:nth-child(2) {
            & span {
              border: none !important;
            }
          }
        }
      }
    }
    & input {
      border: none;
      font-size: 14px;
      font-family: "neue-haas-grotesk-text";
      width: ${(props) => (props.width ? props.width : "15rem")};
      &:disabled {
        -webkit-text-fill-color: rgb(0, 0, 0) !important;
        background-color: #f6f6f6;
        caret-color: rgb(0, 0, 0);
        color: rgb(216, 218, 218);
        font-family: "neue-haas-grotesk-text";
        font-size: 14px;
        line-height: 1.25rem;
        letter-spacing: 0.03125rem;
        margin: 0px;
        padding: 12px;
        width: 100% !important;
      }
      &:focus {
        outline: none;
      }
      &:hover {
        border: ${(props) => getBorderStyle(props)};
        border-radius: ${(props) => (props.disabled ? "none" : "4px")};
      }
    }
  }
`;

const Required = styled.span`
  color: #0077b4 !important;
  font-size: 14px !important;
  margin: ${(props) => (props.margin ? props.margin : "")};
`;

const getBorderStyle = (props) => {
  if (props.disabled) {
    return "none";
  }
  if (props.isError) {
    return "1px solid #c44904 !important";
  }
  return "1px solid black !important";
};

const RedesignedInput = (props) => {
  return (
    <CustomInputWrapper
      isError={props?.error}
      width={props?.width}
      marginTop={props?.marginTop}
      required={props?.isRequired}
      disabled={props?.isDisabled}
    >
      <Input
        id={props?.id}
        type="text"
        label={
          <>
            {props?.label}
            {props?.isRequired && <Required margin="0 0 0 5px">*</Required>}
          </>
        }
        aria-label={props?.ariaLabel}
        disabled={props?.isDisabled}
        value={props.value}
        maxLength={props?.maxLength}
        onChange={(event) => props.handleOnChange(event.target.value)}
        error={props?.error}
        errorText={props?.errorText}
        required={props?.isRequired}
      />
    </CustomInputWrapper>
  );
};

RedesignedInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  handleOnChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  width: PropTypes.string,
  marginTop: PropTypes.string,
  maxLength: PropTypes.string,
};

RedesignedInput.defaultProps = {
  isRequired: false,
  isDisabled: false,
  error: false,
  errorText: "",
  value: "",
  width: "15rem",
};

export default RedesignedInput;
